<template>

	<div class="box size30">
		<h2>Push content to affiliates</h2>

		<div class="success-message" :class="{ 'hidden' : !success }">
			The Instance has been copied successfully.
		</div>

		<ul class="form">
			<li>
				<label>Select content</label>
				<div class="selector">
					<select v-model="selectedInstance">
						<optgroup v-for="(list, entity) in instances" v-bind:key="entity" :label="entity">
							<template v-for="(value, uuid) in list">
								<option v-if="value" v-bind:key="uuid" :value="uuid">
									{{value}}
								</option>
							</template>
						</optgroup>
					</select>
				</div>
			</li>
			<li>
				<label>Affiliates</label>
				<label v-for="region in regions" v-bind:key="region" class="flex-label">
					<input type="checkbox" :value="region" v-model="selectedRegions"> {{region}}
				</label>
			</li>
		</ul>

		<br>
		<button class="btn" @click="pushInstanceToMarkets">Push</button>
	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'pushinstancetomarkets',

	data () {
		return {
			instances: [],
			markets: [],
			regions: [],
			selectedInstance: null,
			selectedMarkets: [],
			selectedRegions: [],
			success: false
		}
	},

	created () {
		this.fetchInstances()
		this.fetchMarkets()
	},

	updated () {

	},

	methods: {
		fetchInstances () {
			xhrModule.get('/cms/api/instances/pushToMarkets/instances',
				data => {
					this.instances = data.data
				}
			)
		},

		fetchMarkets () {
			xhrModule.get(
				'/cms/api/instances/pushToMarkets/markets',
				data => {
					this.markets = data.data
					this.regions = Object.keys(this.markets).reduce((a, k) => {
						if (a.indexOf(this.markets[k].substr(-2)) < 0) {
							a.push(this.markets[k].substr(-2))
						}
						return a
					}, [])

					// tell parent dashboard to update layout
					setTimeout(() => this.$parent.updateLayout(), 10)
				}
			)
		},

		pushInstanceToMarkets (e) {
			e.preventDefault()

			if (this.markets === [] || this.instances === []) {
				return
			}

			// Add loader
			this.$el.parentNode.classList.add('loading')

			// Get user input
			const userInput = () => {
				return {
					instance: this.selectedInstance,
					markets: Object.keys(this.markets).reduce((a, k) => {
						if (this.selectedRegions.indexOf(this.markets[k].substr(-2)) > -1) {
							a.push(k)
						}
						return a
					}, [])
				}
			}

			// Transform JS object to querystring (with PHP array notation)
			const toQueryString = (obj, prefix) => Object.keys(obj).reduce(
				(a, k) => {
					a.push(
						typeof obj[k] === 'object'
							? toQueryString(obj[k], prefix ? prefix + '[' + k + ']' : k)
							: (prefix ? prefix + '[' + k + ']' : k) + '=' + obj[k]
					)
					return a
				},
				[]
			).join('&')

			xhrModule.get(
				'/cms/api/instances/pushToMarkets?' + toQueryString(userInput()),
				data => {
					this.$el.parentNode.classList.remove('loading')
					this.success = true
				}
			)
		}
	}
}

</script>
